// src/utils/parseDoubleEscapedJson.js

/**
 * Safely parses a double-escaped JSON string into a normal JS object.
 * Handles strings like "{\\u0022key\\u0022:\\u0022value\\u0022}".
 *
 * @param {string} input - The JSON string (possibly double-escaped)
 * @returns {object|null} - The parsed object, or null if parsing fails
 */


export function parseDoubleEscapedJson(input) {
  if (typeof input !== 'string') {
    console.warn('parseDoubleEscapedJson: input is not a string.');
    return input;
  }

  try {
    let parsed = JSON.parse(input);

    if (typeof parsed === 'string' && parsed.trim().startsWith('{')) {
      parsed = JSON.parse(parsed);
    }

    return parsed;
  } catch (error) {
    console.error('Error parsing double-escaped JSON:', error);
    return null;
  }
}
